import { FtblPlayerInfo } from './ftblPlayerInfo.types';

export const parseFtblPlayerInfo = (playerInfoRaw: string): FtblPlayerInfo | null => {
    if (!playerInfoRaw) {
        return null;
    }

    try {
        return JSON.parse(playerInfoRaw) as FtblPlayerInfo;
    } catch {
        return null;
    }
};
import { FtblPlayerInfo } from './ftblPlayerInfo.types';

export const parseFtblPlayerInfo = (playerInfoRaw: string): FtblPlayerInfo | null => {
    if (!playerInfoRaw) {
        return null;
    }

    try {
        return JSON.parse(playerInfoRaw) as FtblPlayerInfo;
    } catch {
        return null;
    }
};
